(function () {
  const CONTEXTS = [
    {
      root: '.search-modal',
      input: '.search__input',
      trending: '[data-search-trending]',
      predictive: '[data-predictive-search]',
      resetForm: 'form.search'
    },
    {
      root: '#menu-drawer',
      input: '.menu-drawer__search .search__input',
      trending: '.menu-drawer__search [data-search-trending]',
      predictive: '.menu-drawer__search [data-predictive-search]',
      resetForm: '.menu-drawer__search-form'
    }
  ];

  let isPointerDownInTrending = false;
  let blurTimeout = null;

  document.addEventListener(
    'mousedown',
    (e) => {
      if (e.target.closest('[data-search-trending]')) {
        isPointerDownInTrending = true;
      }
    },
    true
  );

  document.addEventListener(
    'mouseup',
    () => {
      isPointerDownInTrending = false;
    },
    true
  );

  const toggleTrendingInRoot = (rootEl, config) => {
    if (!rootEl) return;

    const input = rootEl.querySelector(config.input);
    const trending = rootEl.querySelector(config.trending);
    const predictive = rootEl.querySelector(config.predictive);

    if (!input || !trending) return;

    const isEmpty = !input.value || !input.value.trim();
    const isFocused = document.activeElement === input;

    const showTrending = isEmpty && isFocused;

    trending.style.display = showTrending ? 'block' : 'none';
    if (predictive) predictive.style.display = showTrending ? 'none' : '';
  };

  const toggleAll = () => {
    CONTEXTS.forEach((ctx) => {
      const rootEl = document.querySelector(ctx.root);
      toggleTrendingInRoot(rootEl, ctx);
    });
  };

  document.addEventListener('DOMContentLoaded', toggleAll);

  document.addEventListener('input', (e) => {
    if (!e.target) return;

    if (
      e.target.matches('.search-modal .search__input') ||
      e.target.matches('.menu-drawer__search .search__input')
    ) {
      toggleAll();
    }
  });

  document.addEventListener('toggle', (e) => {
    if (e.target && e.target.closest && e.target.closest('details-modal.header__search')) {
      setTimeout(toggleAll, 0);
    }

    if (e.target && e.target.id === 'Details-menu-drawer-container') {
      setTimeout(toggleAll, 0);
    }
  });

  document.addEventListener('reset', (e) => {
    if (!e.target) return;

    if (e.target.matches('form.search') || e.target.matches('.menu-drawer__search-form')) {
      setTimeout(toggleAll, 0);
    }
  });

  document.addEventListener('focusin', (e) => {
    if (!e.target) return;

    if (
      e.target.matches('.search-modal .search__input') ||
      e.target.matches('.menu-drawer__search .search__input')
    ) {
      toggleAll();
    }
  });

  document.addEventListener('focusout', (e) => {
    if (!e.target) return;

    const isSearchInput =
      e.target.matches('.search-modal .search__input') ||
      e.target.matches('.menu-drawer__search .search__input');

    if (!isSearchInput) return;

    if (blurTimeout) clearTimeout(blurTimeout);

    blurTimeout = setTimeout(() => {
      if (isPointerDownInTrending) return;
      toggleAll();
    }, 150);
  });
})();